import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ClearFormErrors,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/ResetShippingAddressFormValidation";

addToChainAfter(chain, ClearFormErrors, async props => {
    props.dispatch({
        type: "Components/MyAccount/SetNewShippingAddressFormErrors",
        formErrors: {},
    });
});
